module.exports = __webpack_public_path__ + "media/images/country_flags/kr-7daec510f4e116f2a8450c657a38237e.png";